import { connect } from "react-redux";
import { sessionSlice } from "../../store/sessionSlice";
import About from "../views/about";

const mapStateToProps = (state) => {
  return {
    isConnectedToASession: state.session.sessionStatus === "ACTIVE" || state.session.sessionStatus === "MINIMIZING",
    isConnected: state.session.isConnected,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onStartConnecting: () => dispatch(sessionSlice.actions.startConnecting()),
});


export const AboutViewContainer = connect(mapStateToProps, mapDispatchToProps)(About);
